<template lang="pug">
  app-modal(
    titulo="Cancelar Retificação",
    :width="width"
    @closeModal="closeModal"
  )
    template(slot="body")
      h4 Assunto: Cancelamento de Retificação - Processo n° {{numeroProcesso}}
      app-label(
        label="Informe o motivo do cancelamento:",
        :required="true"
      )
      validation-observer(ref='validation' tag='form')
        validation-provider(rules="required", v-slot="{ errors }")
          app-editor-texto.input(
            :value="conversa",
            @onTextChange="setConversa"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small"
          @click="enviar"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>
<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppModal,
    AppEditorTexto,
    AppLabel
  },

  data () {
    return {
      conversa: ''
    }
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    numeroProcesso: {
      required: false
    },
    setor: {
      required: false
    },
    width: {
      required: false
    }
  },

  methods: {
    ...mapActions({
      cancelarRetificacao: 'processo/cancelarRetificacaoProcesso'
    }),
    setConversa (value) {
      this.conversa = value
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    closeModal () {
      this.$confirm(
        'Ao fechar a tela, os dados preenchidos serão perdidos e a retificação não será cancelada. Tem certeza que seja confirmar esta ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.$emit('closeModal')
        })
        .catch(() => {
        })
    },
    async enviar () {
      if (!await this.checkValidacao()) {
        return
      }
      const conversa = {
        conversa: {
          assunto: 'Cancelamento de Retificação',
          processo: {
            numeroProcesso: this.numeroProcesso
          },
          mensagemList: [
            {
              conteudo: this.conversa
            }
          ]
        },
        setor: this.setor
      }
      this.$confirm(
        'Ao confirmar essa ação, o pedido de retificação para esse cadastro será cancelado. Tem certeza que deseja confirmar essa ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then((action) => {
          this.cancelarRetificacao(conversa).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'A retificação foi cancelada.')
          }).catch(() => {
          }).finally(() => {
            this.$emit('closeModal')
            this.$emit('refresh')
          })
        }).catch(() => {
        })
    }
  }
}
</script>
<style>

.divider {
  border-bottom: solid 2px #dfe4ed;
  width: 100%;
}

.margin40 {
  margin-top: 40px;
}

.padding {
  padding-top: 10px;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalCancelarRetificacao.vue